import './TextInput.scss'
import React from 'react'
import classnames from 'classnames'

const TextInput = ({ label, status, value, className, onChange, onEnter, autoFocus, ...rest }) => {
  return (
    <label className={classnames('TextInput', className)}>
      <span className='TextInput_label'>{label}</span>
      <input
        {...rest}
        value={value || ''}
        autoFocus={autoFocus ? window.innerWidth > 480 : null}
        onChange={e => onChange(e.target.value)}
        onKeyUp={e => e.keyCode === 13 && onEnter && onEnter()}
      />
      {status && (
        <span className='TextInput_status'>{status}</span>
      )}
    </label>
  )
}

TextInput.displayName = 'TextInput'

TextInput.defaultProps = {
  type: 'text'
}

export default TextInput



// WEBPACK FOOTER //
// ./src/lib/TextInput.js